<template>
  <div v-can="['admin', 'users.access']">
    <b-row>
      <b-col md="12">
        <b-card title="مدیریت کاربران">
          <el-table
            class="table text-center"
            :data="users"
            stripe
            border
            style="width: 100%"
          >
            <el-table-column width="80" prop="id" label="#" sortable>
            </el-table-column>

            <el-table-column
              prop="name"
              align="center"
              label="نام و نام خانوادگی"
              sortable
            >
            </el-table-column>

            <el-table-column
              prop="username"
              align="center"
              label="نام کاربری"
              sortable
            >
            </el-table-column>

            <el-table-column label="نقش کاربر" align="center">
              <template slot-scope="scope">
                <small
                  @click="show(scope.row.id)"
                  v-if="scope.row.role != 'بدون نقش کاربری'"
                >
                  {{ scope.row.role }}</small
                >
                <small v-else class="color-red" @click="show(scope.row.id)">
                  {{ scope.row.role }}</small
                >
              </template>
            </el-table-column>

            <el-table-column label="وضعیت کاربر" align="center">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.active == 'true'"
                  size="mini"
                  @click="active(scope.row.id)"
                  >فعال</el-tag
                >
                <el-tag
                  v-else-if="scope.row.active == 'false'"
                  @click="active(scope.row.id)"
                  type="warning"
                  size="mini"
                  >غیرفعال</el-tag
                >
              </template>
            </el-table-column>

            <el-table-column align="center">
              <template slot="header" slot-scope="scope">
                <input
                  v-model="search"
                  size="mini"
                  @keyup="searchinput"
                  :class="scope.$index"
                  placeholder="جستجو ..."
                />
              </template>
              <template slot-scope="scope">
                <router-link
                  :to="`/work/view/${scope.row.id}`"
                  class="btn btn-sm btn-clean btn-icon"
                  v-tooltip="{ content: 'مدیریت نقش' }"
                >
                  <span class="svg-icon svg-icon-md">
                    <i class="la la-edit"></i>
                  </span>
                </router-link>

                <button
                  class="btn btn-sm btn-clean btn-icon"
                  v-tooltip="{ content: 'حذف نقش' }"
                >
                  <span class="svg-icon svg-icon-md">
                    <i class="la la-trash"></i>
                  </span>
                </button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev, pager, next"
            :total="meta.total"
            :page-size="15"
            :page-count="meta.per_page"
            :current-page="meta.current_page"
            @current-change="changepage"
          >
          </el-pagination>
        </b-card>
      </b-col>
    </b-row>

    <vs-dialog v-model="active">
      <b-row>
        <b-col cols="1"> </b-col>
        <b-col cols="8">
          <b-form-group label="نقش کاربر">
            <b-form-select
              v-model="role"
              :options="rolesopstion"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="3 pt-4"
          ><b-button class="mt-5" @click="addrole">ذخیره</b-button></b-col
        >
      </b-row>
    </vs-dialog>
  </div>
</template>
<script>
import ApiService from "@/core/services/api.service";

export default {
  name: "",
  data() {
    return {
      users: [],
      active: false,
      page: 0,
      id: "",
      search: "",
      value: "",
      role: "",
      links: [],
      meta: [],
      rolesopstion: []
    };
  },
  created() {
    this.getall();
  },
  methods: {
    show(id) {
      this.active = true;
      this.id = id;
    },
    addrole() {
      ApiService.post("auth/rpu", {
        id: this.id,
        role: this.role
      })
        .then(({ data }) => {
          this.changepage(this.page);
          this.active = false;

          this.$vs.notification({
            progress: "auto",
            color: "warning",
            position: "bottom-left",
            text: "نقش با موفقیت ذخیره شد"
          });
        })
        .catch(({ response }) => {});
    },
    getall: function() {
      let thisv = this;
      ApiService.post("auth/Users", {})
        .then(({ data }) => {
          thisv.users = data.data;
          thisv.meta = data.meta;
          thisv.links = data.links;
        })
        .catch(({ response }) => {});

      if (this.rolesopstion.length == 0) {
        ApiService.post("auth/roles", {})
          .then(({ data }) => {
            thisv.rolesopstion = data;
          })
          .catch(({ response }) => {});
      }
    },
    changepage: function(page) {
      let thisv = this;
      this.page = page;
      ApiService.post("auth/Users?page=" + page, {})
        .then(response => {
          thisv.users = response.data.data;
          thisv.meta = response.data.meta;
          thisv.links = response.data.links;
        })
        .catch(({ responsea }) => {});
    },
    searchinput: function(event) {
      let search = this.search;
      if (this.search.length > 3) {
        let thisv = this;

        ApiService.post("auth/Users/search", {
          search
        })
          .then(response => {
            thisv.users = response.data.data;
            thisv.meta = response.data.meta;
            thisv.links = response.data.links;
          })
          .catch(({ responsea }) => {});
      } else if (this.search.length == 0) {
        this.changepage(this.page);
      }
    }
  }
};
</script>
<style>
.color-red {
  color: brown;
}
</style>
